<template>
  <div v-if="showPopup" id="popup-container" :class="$style.popup">
    <div :class="$style.cover"></div>
    <div :class="$style.wrapper">
      <div :class="$style.text">
        <p> 現在プレビューモード中であるため、機能は制限されています。 </p>
      </div>
      <div :class="$style.btnPanel">
        <span
          v-if="msg.btn.confirm"
          :class="$style.btnItem"
          :style="{ width: (1 / btns) * 100 + '%' }"
        >
          <span :class="[$style.btn, $style.confirm]" @click="confirm">{{
            msg.btn.confirm
          }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PopupPreview',
  data() {
    return {
      btns: 1,
      showPopup: true,
      msg: {
        close: false,
        btn: {
          confirm: 'OK',
        },
      },
    }
  },
  beforeCreate() {
    var exsistPopupEl = document.getElementById('popup-container')
    if (exsistPopupEl) {
      document.body.removeChild(exsistPopupEl)
    }
  },
  updated() {
    this.btns = this.literal(this.msg.btn)
  },
  methods: {
    confirm() {
      this.showPopup = false
    },
    literal(o) {
      const arr = []
      for (const k in o) {
        if (o[k]) {
          arr.push(o[k])
        }
      }
      return arr.length
    },
  },
}
</script>
<style lang="scss" module>
// @import '@design';
.popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  .cover {
    width: 100vw;
    height: 100vh;
    background: #000;
    opacity: 0.6;
  }
  .wrapper {
    position: fixed;
    top: 25vh;
    left: 5vw;
    width: 90vw;
    max-height: 80%;
    padding: 15px;
    background: #fff;
    border-radius: 10px;
    .text {
      max-height: calc(80% - 110px);
      padding: 10px 0;
      overflow-y: auto;
    }
    .btnPanel {
      margin-top: 10px;
      text-align: center;
      span {
        display: inline-block;
      }
      .btnItem {
        text-align: right;
        .btn {
          box-sizing: border-box;
          width: 100%;
          height: 35px;
          line-height: 35px;
          text-align: center;
          cursor: pointer;
          border: 1px solid #070141;
          border-radius: 8px;
        }
        .confirm {
          color: #fff;
          background: #070141;
        }
      }
    }
  }
}
</style>
